<template>
    <nav class="mt-2" v-if="Object.keys(config).length">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <router-link v-for="(link, i) in links" :key="i" :to="{ name: link.name }" custom
                v-slot="{ href, route, navigate, isActive, isExactActive }">
                <li class="nav-item" :class="{ 'menu-open': link.isOpen, 'menu-is-opening': link.isOpen }"
                    v-if="link.childs !== undefined && link.childs.length && !link?.isDisabled">
                    <a :href="href" @click="navigate" class="nav-link" :class="{ active: link.isActive }">
                        <i :class="'nav-icon ' + link.ico" aria-hidden="true"></i>
                        <p>
                            {{ ' ' + $t('sidebarmenu.' + link.title) + ' ' }}
                            <!-- Исправляем обработчик клика на стрелочку -->
                            <i class="right fa fa-angle-left" @click.prevent.stop="toggleMenu(i)"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <router-link v-for="(child, j) in link.childs" :key="j" :to="{ name: child.name }" custom
                            v-slot="{ href, route, navigate, isActive, isExactActive }">
                            <li class="nav-item" v-if="(!child.permission || $store.getters['users/hasPermission'](child.permission)) && !child?.isDisabled">
                                <a class="nav-link" :class="{ active: isActive }" :href="href" @click="navigate">
                                    <i :class="'ms-**-2 nav-icon ' + child.ico" aria-hidden="true"></i>
                                    <p>{{ $t('sidebarmenu.' + child.title) }}</p>
                                    <a v-if="child.badge" :class="child.badge.classes" href="#" class="">{{
                                        child.badge.text }}</a>
                                </a>
                            </li>
                        </router-link>
                    </ul>
                </li>
                <li class="nav-item" v-else-if="!link?.isDisabled">
                    <a class="nav-link" :class="{ active: isActive }" :href="href" @click="navigate">
                        <i :class="'nav-icon ' + link.ico" aria-hidden="true"></i>
                        <p>{{ ' ' + $t('sidebarmenu.' + link.title) + ' ' }}</p>
                    </a>
                </li>
            </router-link>
            <li class="nav-item">
                <a href="#" class="nav-link" @click="logout">
                    <i class="fa fa-sign-out nav-icon" aria-hidden="true"></i>
                    <p>{{ $t('auth.logout') }}</p>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>

import { useStore, mapState } from 'vuex'
import stringMixin from 'mixins/string'

export default {
    props: ['value'],
    mixins: [stringMixin],
    data: () => ({
        links: [
            {
                name: 'dashboard',
                ico: 'fa fa-home',
                title: 'dashboard'
            },
            {
                name: 'reservations',
                ico: 'fa fa fa-users',
                title: 'reservations_main',
                disable: 'main.disable_reservation_section',
                childs: [
                    {
                        name: 'reservations',
                        ico: 'fa fa-id-card',
                        title: 'reservations',
                        disable: 'reservations.disable',
                    },
                    {
                        name: 'tourists',
                        ico: 'fa fa-users',
                        title: 'tourists',
                        disable: 'tourists.disable',
                    },
                    {
                        name: 'payments',
                        ico: 'fa fa-credit-card',
                        title: 'payments',
                        permission: 'HOTELPAYMENTS',
                        disable: 'payments.disable',
                    },
                    {
                        name: 'pricenegotiation',
                        ico: 'fa fa-comments',
                        title: 'price_negotiation',
                        permission: 'HOTELNETCONSENT',
                        disable: 'pricenegotiation.disable',
                    }
                ]
            },
            {
                name: 'hotels',
                title: 'hotels',
                ico: 'fa fa-university',
                disable: 'main.disable_hotel_section',
                childs: [
                    {
                        name: 'hotels',
                        ico: 'fa fa-university',
                        title: 'hotels_info',
                        disable: 'hotel.disable'
                    },
                    {
                        name: 'allotment',
                        ico: 'fa fa-th',
                        title: 'allotments',
                        permission: 'HOTELALLOCATION',
                        disable: 'allotment.disable'
                    },
                    {
                        name: 'stopsale',
                        ico: 'fa fa-hand-paper-o',
                        title: 'stop_sale',
                        permission: 'HOTELSTOPSALE',
                        disable: 'stopsale.disable'
                    },
                    {
                        name: 'contracts',
                        ico: 'fa fa-shield',
                        title: 'contracts',
                        disable: 'contracts.disable'
                     },
                     {
                        name: 'supplements',
                        ico: 'fa fa-plus-square-o',
                        title: 'supplements',
                        disable: 'supplements.disable'
                     },
                    {
                        name: 'prices',
                        ico: 'fa fa-money',
                        title: 'prices',
                        permission: 'HOTELSHOWSPOLIST',
                        disable: 'prices.disable',
                    },
                ]
            },
            {
                name: 'subscription',
                title: 'subscription',
                ico: 'fa fa-paper-plane',
                disable: 'subscription.disable'
            },
        ],
        sidebarElementId: 'sidebar-overlay'
    }),
    methods: {
        toggleMenu(index) {
            this.links[index].isOpen = !this.links[index].isOpen;
        },

        logout(e) {
            this.$store.dispatch('users/logout', this.$router);
        },

        preparedLinks(config) {
            const links = this.links;

            links.forEach((link, i) => {
                const isDisabled = this.getDeepValue(config, link.disable, false);
                const childs = link.childs;
                link.isDisabled = isDisabled;
                if (link.childs !== undefined && link.childs.length) {
                    childs.forEach((child) => {
                        child.isDisabled = this.getDeepValue(config, child.disable, false);
                    });
                }
            });
        },

        formatLinks(notOpen = false) {
            const links = this.links;
            const self = this;
            links.forEach((link, i) => {
                if (link.childs !== undefined && link.childs.length) {
                    const childs = link.childs;
                    let isOpen = false;
                    let isActive = false;

                    childs.forEach((child) => {
                        if (child.name === self.currentRouteName) {
                            isOpen = true;
                            isActive = true;
                        }
                    });

                    link.isOpen = isOpen;
                    link.isActive = isActive;
                }
            });
        },

        sidebarClose() {
            this.$store.commit('toggleSidebar', false);
        },

        getSidebarDisplay() {
            return window.getComputedStyle(document.getElementById(this.sidebarElementId)).display;
        }
    },
    computed: {
        ...mapState({
            openSidebar: state => state.openSidebar,
            user: state => state.users.user,
            config: state => state.config,
        }),
        currentRouteName() {
            return this.$route.name;
        },
        currentRoutePath() {
            return this.$route.path
        }
    },
    watch: {
        $route(to, from) {
            this.formatLinks(true);
            if (to.name === 'dashboard') {
                this.links.forEach(link => {
                    if (link.childs) {
                        link.isOpen = false;
                    }
                });
            }
            if ((to.name != from.name) && this.getSidebarDisplay() != 'none') {
                this.sidebarClose();
            }
        },
        config: {
            handler(config) {
                this.preparedLinks(config);
            },
            deep: true
        },
    },
    mounted() {
        if(Object.keys(this.config).length)
            this.preparedLinks(this.config);
        this.formatLinks();
    }

}
</script>

<style>
.nav-link i.right{
    position: absolute !important;
    top: 0 !important;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: 0 15px;
    right: 0 !important;
}
@media (max-width: 1050px) {
    .sidebar-open #sidebar-overlay {
        display: block;
    }
}
</style>
